import { useTranslation } from '@portals-platform/i18n';
import {
  ComboboxField,
  CurrencyField,
  FormField,
  FormGrid,
  RepeaterRows,
  useFormContext,
  useWatch,
} from '@portals-platform/ui-forms';
import { useStorageLocationOptions } from '../../../data-access/index.js';
import { createEmptyStorageLocation } from '../../../lib/new-certificate/defaults.js';
import { useSelectedCountryName } from '../../../lib/new-certificate/hooks/use-selected-country-name.js';
import type { FormValues } from '../../../lib/new-certificate/types.js';
import { CertificateSection } from './certificate-section.js';

export function StorageCoverageSection() {
  const { t } = useTranslation();
  const { control } = useFormContext<FormValues>();
  const [policyYear, countryCode, currency, storageLocations] = useWatch({
    control,
    name: ['policyYear', 'countryCode', 'currency', 'storageLocations'],
  });
  const storageLocationOptions = useStorageLocationOptions({
    policyYear,
    countryCode,
    countryName: useSelectedCountryName(),
  });
  const label = t('certificates.new.storage.storageLocation');

  return (
    <CertificateSection title={t('certificates.new.sections.storageCoverage')}>
      <RepeaterRows
        name="storageLocations"
        makeEmpty={() => createEmptyStorageLocation(storageLocations.length + 1)}
        addLabel={t('certificates.new.storage.addLocation')}
        emptyLabel={t('certificates.new.storage.empty')}
        rowLabel={(index) => `${label} ${index + 1}`}
      >
        {({ field }) => (
          <FormGrid>
            <FormField name={field('storageLocation')} label={label} required>
              <ComboboxField
                name={field('storageLocation')}
                options={storageLocationOptions}
                placeholder={t('certificates.new.storage.selectStorageAddress')}
                searchPlaceholder={t('certificates.new.storage.searchStorageAddress')}
              />
            </FormField>

            <FormField
              name={field('limitStorage')}
              label={t('certificates.new.storage.limitStorage')}
              required
            >
              <CurrencyField
                name={field('limitStorage')}
                currency={currency || 'USD'}
                locale="en-GB"
              />
            </FormField>
          </FormGrid>
        )}
      </RepeaterRows>
    </CertificateSection>
  );
}
